/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.31/esri/copyright.txt for details.
*/
import{ManipulatorStateFlags as t}from"../../interactive/interfaces.js";class e{constructor(e,s=t.None){this.geometry=e,this.stateMask=s}}export{e as RenderObject};
